import { render } from "./ViewWorkout.vue?vue&type=template&id=38a29083"
import script from "./ViewWorkout.vue?vue&type=script&lang=js"
export * from "./ViewWorkout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\Workout-Tracker\\workout-tracker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])